import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
